import { BROADCAST_SET_MEDIA_PLAYER_SETTINGS } from 'actions/Types';

function setMediaPlayer(mediaPlayer) {
  return dispatch => {
    const action = {
      type: BROADCAST_SET_MEDIA_PLAYER_SETTINGS,
      payload: mediaPlayer
    };

    dispatch(action);
  };
}

export default setMediaPlayer;
